import { Account } from '@/domain/usecases'
import { UserRefundProgramList } from '@/domain/usecases/refund/user-refund-program-list'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import AddonBaseLoader from '../addons-base-loader'

export default class RefundProgramListLoader extends AddonBaseLoader {
  static readonly ADDON_NAME = 'refund'

  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined
  ) {
    super(
      account,
      queryClient,
      ldClient,
      FeatureFlag.Key.DEFAULT_TRUE,
      RefundProgramListLoader.ADDON_NAME
    )
  }

  async loader() {
    return this.defer({
      data: super.importRemoteModule('makeRemoteUserRefundProgramList').then(async makeRemote => {
        const remote = makeRemote(this.queryClient) as UserRefundProgramList
        return remote.get()
      })
    })
  }
}
